import { env } from "../../../env";
import { IAppsFields } from "../../../types/appstore";

export const checkGoToOlderSettingsPage = (app: Partial<IAppsFields>) => {
  return (
    !app.newSettingsPage || // If app doesn't have a settings page
    (app.newSettingsPage &&
      !app.settingsEnabledInProd &&
      env.NODE_ENV === "production") || // Has a settings page, but it's not available in prod, and you are in prod
    (app.newSettingsPage &&
      !app.settingsEnabledInStage &&
      env.NODE_ENV === "stage") // Has a settings page, but it's not available in stage, and you are in stage
  );
};

/**
 * Case insensitive check on a plan type to determine if the plan type grants access to the app
 */
export const hasAppAccess = (
  app: Partial<IAppsFields>,
  client: { planType?: string },
) => {
  // Check if a plan is FREE
  if (!app.proOnly && !app.maxOnly) {
    return true;
  }

  // Check if a plan is PRO
  if (
    app.proOnly &&
    (client.planType?.toUpperCase() === "PRO" ||
      client.planType?.toUpperCase() === "MAX")
  ) {
    return true;
  }

  // Check if a plan is MAX
  if (app.maxOnly && client.planType?.toUpperCase() === "MAX") {
    return true;
  }

  return false;
};
